import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'var(--ev-body-text)',
    h1: {
      fontFamily: 'var(--ev-header-text)',
    },
    h2: {
      fontFamily: 'var(--ev-header-text)',
    },
    h3: {
      fontFamily: 'var(--ev-header-text)',
    },
    h4: {
      fontFamily: 'var(--ev-header-text)',
    },
    h5: {
      fontFamily: 'var(--ev-header-text)',
    },
    h6: {
      fontFamily: 'var(--ev-header-text)',
    },
  },
  palette: {},
});

export default theme;
